import { render, staticRenderFns } from "./ShareLinks.vue?vue&type=template&id=bd247a62&scoped=true"
import script from "./ShareLinks.vue?vue&type=script&lang=js"
export * from "./ShareLinks.vue?vue&type=script&lang=js"
import style0 from "./ShareLinks.vue?vue&type=style&index=0&id=bd247a62&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd247a62",
  null
  
)

export default component.exports